import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import {
  canAccessReportsArea,
  getFirstAccessibleReportRoute,
} from "@/lib/utils/reports/report-navigation";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_auth/reports/")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { hasPagePermission } = useUser();

  const defaultReportRoute = getFirstAccessibleReportRoute(hasPagePermission);
  const canAccessReports = canAccessReportsArea(hasPagePermission);

  useEffect(() => {
    if (defaultReportRoute) {
      void navigate({ to: defaultReportRoute, replace: true });
    }
  }, [defaultReportRoute, navigate]);

  if (!canAccessReports || !defaultReportRoute) {
    return <GlobalNotAuthorized />;
  }

  return null;
}
